/**
 * @author Artem Lytvynov
 * @copyright Artem Lytvynov
 * @license Apache-2.0
 */

export enum TABLE_TYPE_VALUES {
  TABLE = "table",
  QUERY = "query",
}
